import { useSearchParams, useNavigate } from 'react-router-dom';
import { Paper, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const AuthError: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const classes = useStyles();

    const rawMessage = searchParams.get('message');
    const message = rawMessage 
        ? decodeURIComponent(rawMessage) 
        : 'אירעה שגיאה בתהליך ההתחברות באמצעות משרד החינוך.';

    return (
        <div className={classes.root}>
            <Paper className={classes.paper} elevation={3}>
                <ErrorOutlineIcon className={classes.icon} />
                <Typography variant="h5" className={classes.title}>
                    שגיאת התחברות
                </Typography>
                <Typography className={classes.message}>
                    {message}
                </Typography>
                <Button 
                    variant="contained" 
                    color="primary" 
                    className={classes.button}
                    onClick={() => navigate('/login')}
                >
                    חזרה לדף ההתחברות
                </Button>
            </Paper>
        </div>
    );
};

export default AuthError;

const useStyles = makeStyles({
    root: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f7fb',
        padding: '20px',
        direction: 'rtl',
    },
    paper: {
        maxWidth: '500px',
        width: '100%',
        padding: '40px 30px',
        textAlign: 'center',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
    },
    icon: {
        fontSize: '64px',
        color: '#f44336',
    },
    title: {
        fontWeight: 'bold',
        color: '#24364b',
        fontFamily: 'Assistant',
    },
    message: {
        fontSize: '18px',
        color: '#657786',
        lineHeight: 1.6,
        fontFamily: 'Assistant',
        whiteSpace: 'pre-line',
    },
    button: {
        marginTop: '10px',
        padding: '10px 30px',
        fontSize: '16px',
        fontWeight: 'bold',
        borderRadius: '8px',
        fontFamily: 'Assistant',
    },
});
